import React from 'react'
import { FormikHelpers } from 'formik'
import { Wizard, WizardStep } from 'components'

import {
  AccidentFields,
  validationSchema as accidentValidation,
} from './AccidentFields'
import {
  DriverFields,
  validationSchema as driverValidation,
} from './DriverFields'
import {
  DamageFields,
  validationSchema as damageValidation,
} from './DamageFields'
import {
  SummaryFields,
  validationSchema as summaryValidation,
} from './SummaryFields'
import { FormDamage, FormDamageReport } from './types'

export const createInitialDamages = (): FormDamage => ({
  bumperFront: false,
  bumperBack: false,
  fenderLeft: false,
  fenderRight: false,
  engineCooler: false,
  engineHood: false,
  frontDoorLeft: false,
  frontDoorRight: false,
  sidePanelOrDoorLeft: false,
  sidePanelOrDoorRight: false,
  tailgate: false,
  tires: {
    frontLeft: false,
    frontRight: false,
    rearLeft: false,
    rearRight: false,
  },
  window: '',
  hadWindow: false,
  other: '',
  hadOther: false,
})

export const initialValues: FormDamageReport = {
  // AccidentFields
  licensePlate: '',
  date: '',
  time: '',
  street: '',
  postcode: '',
  city: '',
  description: '',
  hadPoliceReport: undefined,
  policeReport: '',
  vehicleDrivable: undefined,
  vehicleLocation: {
    street: '',
    postcode: '',
    city: '',
    description: '',
  },
  // DriverFields
  reporterIsDriver: undefined,
  driver: {
    firstName: '',
    lastName: '',
    street: '',
    postcode: '',
    city: '',
    phone: '',
    birthday: '',
    hadPermission: undefined,
    permission: '',
    licenseAware: undefined,
  },
  driverHadLicense: undefined,
  driverHadDrugs: undefined,
  driverDrugs: '',
  // DamageFields
  multipleVehicles: undefined,
  damage: createInitialDamages(),
  otherVehicleDamage: createInitialDamages(),
  otherVehicleLicensePlate: '',
  hadTrailer: undefined,
  hadOtherDamages: undefined,
  otherDamages: '',
  summaryRead: false,
}

interface DamageReportFormProps {
  onSubmit: (values: any, helpers: FormikHelpers<FormDamageReport>) => void
}

export const DamageReportForm: React.FunctionComponent<DamageReportFormProps> = ({
  onSubmit,
}) => (
  <Wizard initialValues={initialValues} onSubmit={onSubmit}>
    <WizardStep
      name="pages.damageReports.damageReportForm.damageReportForm.accident"
      validationSchema={accidentValidation}
    >
      <AccidentFields />
    </WizardStep>
    <WizardStep
      name="pages.damageReports.damageReportForm.damageReportForm.driver"
      validationSchema={driverValidation}
    >
      <DriverFields />
    </WizardStep>
    <WizardStep
      name="pages.damageReports.damageReportForm.damageReportForm.dmage"
      validationSchema={damageValidation}
    >
      <DamageFields />
    </WizardStep>
    <WizardStep
      name="pages.damageReports.damageReportForm.damageReportForm.summary"
      validationSchema={summaryValidation}
    >
      <SummaryFields />
    </WizardStep>
  </Wizard>
)
